var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col space-y-5"},_vm._l((_vm.carouselInfo),function(ref,index){
var title = ref.title;
var items = ref.items;
return _c('ProductsCarousel',{key:index,attrs:{"title":title,"products":items},scopedSlots:_vm._u([{key:"sub-title",fn:function(){return [_c('SectionTitle',{staticClass:"text-primary-700 text-sm justify-center",attrs:{"dir":"left"}},[_vm._v(" "+_vm._s(_vm.subTitle)+" ")])]},proxy:true}],null,true)})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }